import { PreviewImageModal } from '@exam-center/components';
import { Box, Flex, Text, Image } from '@shared/components';
import { useDisclosure } from '@shared/hooks';
import { useState } from 'react';

interface ReadonlyFormImagesInputProps {
  label?: string;
  images: string[];
}

export default function ReadonlyFormImagesInput(props: Readonly<ReadonlyFormImagesInputProps>) {
  const { label, images } = props;

  const [previewImage, setPreviewImage] = useState<string | null>(null);
  const [isPreviewModalOpen, { open: openPreviewModal, close: closePreviewModal }] =
    useDisclosure();

  return (
    <>
      <Flex
        sx={{
          width: '100%',
          flexDirection: 'column',
          gap: (theme) => theme.spacing(1),
        }}
      >
        {label ? (
          <Flex sx={{ justifyContent: 'space-between' }}>
            <Flex sx={{ gap: (theme) => theme.spacing(1) }}>
              <Text variant='body1'>{label}</Text>
            </Flex>
          </Flex>
        ) : null}

        <Flex
          sx={{
            flexWrap: 'wrap',
            gap: (theme) => theme.spacing(2),
          }}
        >
          {images.map((src, idx) => (
            <Box
              key={idx}
              onClick={(e) => {
                e.stopPropagation();
                openPreviewModal();
                setPreviewImage(src);
              }}
              sx={(theme) => ({
                width: '200px',
                height: '200px',
                position: 'relative',
                borderRadius: theme.shape.rounded(2),
              })}
            >
              <Image
                src={src}
                alt={`Uploaded image ${idx + 1}`}
                sx={(theme) => ({
                  width: '200px',
                  height: '200px',
                  display: 'block',
                  objectFit: 'cover',
                  borderRadius: theme.spacing(2),
                  cursor: 'pointer',
                })}
              />
            </Box>
          ))}
        </Flex>
      </Flex>
      <PreviewImageModal
        open={isPreviewModalOpen}
        image={previewImage ?? ''}
        onClose={closePreviewModal}
      />
    </>
  );
}
